import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Button from '../common/button/button';
import DateFormat from '../common/dateFormat/DateFormat';
import FormatUtils from '../common/formatUtils/FormatUtils';
import ReactExport from 'react-export-excel-fixed-xlsx';
import LabelAndInputMask from '../common/form/labelAndInputMask';
import InputPesquisa from '../common/form/inputPesquisa';
import Aguardando from '../common/template/aguardando';
import Select from '../common/form/select';
import LabelAndInputDate from '../common/form/labelAndInputDate';
import Form from './gestaoVMForm';

import { 
	setModoTela, setFiltro, initForm, excluir, getLista, getListaMotorista, getListaPlaca
} from './gestaoVMActions';
import { 
	getLista as getListaGrupo
} from '../gestaoVMGrupo/gestaoVMGrupoActions';
import { 
	getLista as getListaOperacao
} from '../gestaoVMOperacao/gestaoVMOperacaoActions';
import { 
	getLista as getListaMotivo
} from '../gestaoVMMotivo/gestaoVMMotivoActions';
import { 
	getLista as getListaComentarioTipo
} from '../gestaoVMComentarioTipo/gestaoVMComentarioTipoActions';

class GestaoVM extends Component {

	state = {
		linhaSelecionada: null,
		ordenacao: {
			data_gestao: 2
		},
		paginaAtual: 1,
		linhasPorPagina: 10,
		height: window.innerWidth < 685 ? window.innerHeight - 320 : window.innerHeight - 220
	}

    componentWillMount() {
		this.props.setModoTela('lista');
        this.props.getLista();
		this.props.getListaMotorista();
		this.props.getListaPlaca();
		this.props.getListaGrupo();
		this.props.getListaOperacao();
		this.props.getListaMotivo();
		this.props.getListaComentarioTipo();

		this.calcularLinhasPorPagina();
    }

    render() {
        return (
            <div>
				<Content>
					<Aguardando aguardando={this.props.aguardando} />

					{this.props.modoTela == 'cadastro' ? (
						<Form />
					) : null}
					{this.props.modoTela == 'exclusao' ? (
						<Form excluir />
					) : null}
					{this.props.modoTela == 'lista' ? this.lista() : null}
				</Content>
			</div>
        )
    }

	getNovaOrdenacao(atual) {
		return atual == 2 ? 0 : (atual || 0) + 1;
	}

	getIconeOrdenacao(tipo) {
		if (tipo == 1) {
			return <i class="fas fa-sort-amount-down-alt" />;
		} else if (tipo == 2) {
			return <i class="fas fa-sort-amount-up" />;
		} else {
			return null;
		}
	}

	calcularLinhasPorPagina = () => {
		const alturaDisponivel = this.state.height;
		const alturaLinha = 34.8;
		const quantidade = Math.floor(alturaDisponivel / alturaLinha);

		this.setState({ 
			linhasPorPagina: quantidade > 5 ? quantidade : 5 
		}); 
	}

	lista() {

		const ExcelFile = ReactExport.ExcelFile;
		const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
		const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

		const listaAno = Array.from({ length: 20 },(_, i) => ({ id: 2025 + i, valor: 2025 + i })).filter(ano => ano.id <= new Date().getFullYear());
		const listaMes = [
			{ id: 1, valor: 'Janeiro' }, { id: 2, valor: 'Fevereiro' }, { id: 3, valor: 'Março' }, { id: 4, valor: 'Abril' },
			{ id: 5, valor: 'Maio' }, { id: 6, valor: 'Junho' }, { id: 7, valor: 'Julho' }, { id: 8, valor: 'Agosto' },
			{ id: 9, valor: 'Setembro' }, { id: 10, valor: 'Outubro' }, { id: 11, valor: 'Novembro' }, { id: 12, valor: 'Dezembro' }
		];
		const listaSemana = Array.from({ length: 53 },(_, i) => ({ id: 1 + i, valor: `Semana ${i + 1}` }));

		let lista = this.props.lista.filter(item => {

			return !(this.props.filtro.pesquisar || '').trim()
				|| (this.props.filtro.pesquisar.toUpperCase() || '').split('+').filter(pesquisar => (pesquisar || '').trim()).filter(pesquisar => {
				if (pesquisar
					&& !(`
					${DateFormat.formatarDataSqlParaTela(item.data_gestao)}
					${item.nome_status}
				`).toUpperCase().includes(pesquisar)) {
					return false;
				}

				return true;

			}).length > 0;
			
		});

		if (this.state.ordenacao.data_gestao) {
			lista.sort((a, b) => this.state.ordenacao.data_gestao == 1 
				? (a.data_gestao > b.data_gestao ? 1 : -1) 
				: (a.data_gestao > b.data_gestao ? -1 : 1));
		} else if (this.state.ordenacao.nome_status) {
			lista.sort((a, b) => this.state.ordenacao.nome_status == 1 
				? (a.nome_status > b.nome_status ? 1 : -1) 
				: (a.nome_status > b.nome_status ? -1 : 1));
		}

		const { paginaAtual, linhasPorPagina } = this.state; 
		const totalPaginas = Math.ceil(lista.length / linhasPorPagina) || 1; 
		const inicio = (paginaAtual - 1) * linhasPorPagina; 
		const fim = inicio + linhasPorPagina; 
		const listaPaginada = lista.slice(inicio, fim);

		const heightTela = this.state.height;

		return (
			<ContentCard>
				<ContentCardBody>
					<Row>
						{/*<InputPesquisa
							cols='12 12 4 4'
							maxWidth={350}
							minWidth={350}							
							label='Pesquisar'
							value={this.props.filtro.pesquisar}
							onChange={value => this.props.setFiltro({ ...this.props.filtro, pesquisar: value })} />*/}

						<Select
							name='ano'
							component={Select}
							options={listaAno}
							label='Ano'
							maxWidth={200}
							minWidth={200}
							cols='12 1 1 1'
							placeholder='Selecione'
							value={this.props.filtro.ano}
							onChange={value => {
								this.props.setFiltro({
									...this.props.filtro,
									ano: value
								})
							}} />

						<Select
							name='mes'
							component={Select}
							options={listaMes}
							label='Mês'
							maxWidth={200}
							minWidth={200}
							cols='12 1 1 1'
							placeholder='Selecione'
							value={this.props.filtro.mes}
							onChange={value => {
								this.props.setFiltro({
									...this.props.filtro,
									mes: value
								})
							}} />
						
						<Select
							name='semana'
							component={Select}
							options={listaSemana}
							label='Semana'
							maxWidth={200}
							minWidth={200}
							cols='12 1 1 1'
							placeholder='Selecione'
							value={this.props.filtro.semana}
							onChange={value => {
								this.props.setFiltro({
									...this.props.filtro,
									semana: value
								})
							}} />
						
						<div style={{ width: 310, marginTop: 8, marginLeft: 8 }}>

							<a class='btn btn-app bg-primary' style={{ marginLeft: 2, minWidth: 75 }}
								onClick={() => {
									this.props.getLista();
									this.setState({
										paginaAtual: 1
									});
								}}>
								<i class='fas fa-sync-alt'></i> Atualizar
							</a>

							{/*<a class='btn btn-app bg-primary' style={{ marginLeft: 2, minWidth: 75 }}
								onClick={() => {
									this.props.setModoTela('cadastro', {});
									this.props.initForm({});
								}}>
								<i class='fas fa-plus'></i> Adicionar
							</a>*/}

						</div>
					</Row>

					<div 
						style={{ 
							backgroundColor: '#1F3066',
							marginLeft: -8,
							marginRight: -8,
							marginBottom: -8,
							paddingTop: 1,
							paddingLeft: 8,
							paddingRight: 8,
							paddingBottom: 8,
							height: heightTela
						}}>
						<Table responsive border striped alturaFixa
							maxHeight={heightTela}>
							<THead>
								<Tr backgroundColor={'#1F3066'}
									color={'#ffffff'}
									height={47}>
									<Th paddingTop={2} paddingBottom={2} 
										onClick={() => this.setState({ ...this.state, ordenacao: { data_gestao: this.getNovaOrdenacao(this.state.ordenacao.data_gestao) }})} 
										sticky backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter>Data {this.getIconeOrdenacao(this.state.ordenacao.data_gestao)}</Th>
									<Th paddingTop={2} paddingBottom={2} 
										onClick={() => this.setState({ ...this.state, ordenacao: { nome_status: this.getNovaOrdenacao(this.state.ordenacao.nome_status) }})} 
										sticky backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter>Status {this.getIconeOrdenacao(this.state.ordenacao.nome_status)}</Th>
									<Th paddingTop={2} paddingBottom={2} sticky backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter></Th>
								</Tr>
							</THead>
							<TBody>
								{listaPaginada.map((item, i) => (
									<Tr key={item.id}
										backgroundColor={this.state.linhaSelecionada == item.id ? '#bcc7eb' : (i % 2 == 0 ? '#ffffff' : '#f5f5f5')}
										onClick={() => this.setState({ ...this.state, linhaSelecionada: item.id })} >
										<Td color={'#000'} alignCenter small>{DateFormat.formatarDataSqlParaTela(item.data_gestao)}</Td>
										<Td color={'#000'} alignCenter small>{item.nome_status}</Td>
										<Td minWidth={50} width={150} alignCenter>
											<ButtonTable
												type={'primary'}
												icon={'fas fa-table'}
												visible={true}
												small
												event={() => {
													this.props.setModoTela('cadastro', {
														...item
													});
													this.props.initForm({
														...item
													});
												}} />
										</Td>
									</Tr>
								))}
							</TBody>
						</Table>
					</div>
					<div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 10 }}>
						<div><strong>{lista.length}</strong> registros</div>
						<div style={{ display: 'flex', gap: 5 }}>
							<button className='btn btn-light' disabled={paginaAtual === 1} 
								onClick={() => this.setState({ paginaAtual: 1 })}>
								<i class='fas fa-angle-double-left'></i>
							</button>
							<button className='btn btn-light' disabled={paginaAtual === 1} 
								onClick={() => this.setState({ paginaAtual: paginaAtual - 1 })}>
								<i class='fas fa-angle-left'></i>
							</button>
							<span style={{ padding: '6px 12px', display: 'flex' }}>
								<div style={{ width: 30, textAlign: 'center' }}>{paginaAtual}</div> de <div style={{ width: 30, textAlign: 'center' }}>{totalPaginas}</div>
							</span>
							<button className='btn btn-light' disabled={paginaAtual >= totalPaginas}
								onClick={() => this.setState({ paginaAtual: paginaAtual + 1 })}>
								<i class='fas fa-angle-right'></i>
							</button>
							<button className='btn btn-light' disabled={paginaAtual >= totalPaginas}
								onClick={() => this.setState({ paginaAtual: totalPaginas })}>
								<i class='fas fa-angle-double-right'></i>
							</button>
						</div>
					</div>
				</ContentCardBody>
			</ContentCard>
		);
	}


}

const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	usuarioCarregado: state.auth.usuarioCarregado,
	aguardando: state.gestaoVM.aguardando,
	modoTela: state.gestaoVM.modoTela,
	lista: state.gestaoVM.lista,
	filtro: state.gestaoVM.filtro
});
const mapDispatchToProps = dispatch => bindActionCreators({
	setModoTela, setFiltro, initForm, excluir, getLista, getListaMotorista, getListaPlaca,
	getListaGrupo, getListaOperacao, getListaMotivo, getListaComentarioTipo
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(GestaoVM);
